import React, { Component } from 'react';
import './HeroSlider.scss';
import { Link } from 'react-router-dom';
import { getDocument } from '../../../services/firestore-service';
import Spinner from '../../spinner/Spinner';
import {DESIGN_NAMES} from '../../../helpers';

class HeroSlider extends Component {
    constructor() {
        super();
        this.state = {
            loading: true,
            items: [],
            activeSlideIndex: 0,
            displaySlideIndex: 1,
            transitionEnabled: true
        }
    }

    componentDidMount() {
        getDocument('configurations', 'home_config', false).then(config => {
            if (config) {
                const items = this.buildSlider(config);
                this.setState({ items, loading: false }, this.startAutoPlay);
            } else {
                this.setState({ loading: false });
            }
        }).catch(() => {
            this.setState({ loading: false });
        });
    }

    componentWillUnmount() {
        window.clearInterval(this.autoPlayTimer);
    }

    getLongestArrLength(obj) {
        let max = 0;
        Object.values(obj).forEach(val => {
            if (val && val.length && val.length > max) {
                max = val.length;
            }
        });
        return max;
    }

    buildSlider(slides) {
        const items = [];
        const longest = this.getLongestArrLength(slides);
        for (let i = 0; i < longest; i++) {
            Object.keys(slides).forEach(key => {
                if (slides[key][i]) {
                    items.push({
                        title: DESIGN_NAMES[key],
                        design: key,
                        url: slides[key][i]
                    });
                }
            });
        }
        return items;
    }

    startAutoPlay = () => {
        window.clearInterval(this.autoPlayTimer);

        if (this.state.items.length > 1) {
            this.autoPlayTimer = window.setInterval(this.slideNextFromAutoPlay, 5000);
        }
    }

    getRenderedSlides = () => {
        const { items } = this.state;

        if (items.length <= 1) {
            return items;
        }

        return [
            items[items.length - 1],
            ...items,
            items[0]
        ];
    }

    slideNext = () => {
        this.moveSlide(1);
        this.startAutoPlay();
    }

    slidePrev = () => {
        this.moveSlide(-1);
        this.startAutoPlay();
    }

    slideNextFromAutoPlay = () => {
        this.moveSlide(1);
    }

    moveSlide = (direction) => {
        const { items, activeSlideIndex, displaySlideIndex } = this.state;

        if (items.length <= 1) {
            return;
        }

        this.setState({
            activeSlideIndex: (activeSlideIndex + direction + items.length) % items.length,
            displaySlideIndex: displaySlideIndex + direction,
            transitionEnabled: true
        });
    }

    handleTransitionEnd = () => {
        const { items, displaySlideIndex } = this.state;

        if (displaySlideIndex === 0) {
            this.setState({
                displaySlideIndex: items.length,
                transitionEnabled: false
            });
        }

        if (displaySlideIndex === items.length + 1) {
            this.setState({
                displaySlideIndex: 1,
                transitionEnabled: false
            });
        }
    }

    render() {
        const { items, loading, displaySlideIndex, transitionEnabled } = this.state;
        const renderedSlides = this.getRenderedSlides();
        const trackStyle = {
            transform: `translateX(-${items.length > 1 ? displaySlideIndex * 100 : 0}%)`
        };

        return (
            !loading ? 
            <div className='hero-container header-padding'>
                {items.length > 0 && (
                    <div className='slider'>
                        <div
                            className={`slider-track ${transitionEnabled ? '' : 'no-transition'}`}
                            style={trackStyle}
                            onTransitionEnd={this.handleTransitionEnd}>
                            {renderedSlides.map((item, i) => (
                                <div className='slide'
                                    style={{backgroundImage: `url('${item.url}')`}}
                                    key={`${item.design}-${item.url}-${i}`}>
                                    <div className="gradient"></div>
                                    <div className="content">
                                        <h2 className="heading-text">{item.title}</h2>
                                        <Link to={`/designs/${item.design}`}>
                                            <button className="client-button content__btn">View Style</button>
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {items.length > 1 && (
                            <div className="slider-controls">
                                <i className='material-icons arrow left' onClick={this.slidePrev}>keyboard_arrow_left</i>
                                <i className='material-icons arrow right' onClick={this.slideNext}>keyboard_arrow_right</i>
                            </div>
                        )}
                    </div>
                )}
            </div> :
            <div className="spinner header-padding"><Spinner /></div>
        )
    }
}

export default HeroSlider;
